// extracted by mini-css-extract-plugin
export default {"wrapper":"H3ob","capture":"g97Z","capture-wrapper":"p9Gx","captureWrapper":"p9Gx","video":"t9GT","msg":"d30c"};